import HeaderSection from "../Common/HeaderSection";
import SecondComp from "../Common/SecondComp";
import LearnMoreaboutme from "../Common/LearnMoreaboutme";
import AboutMyWork from "../Common/AboutMyWork";
import SomethingMore from "../Common/SomethingMore";
import FifthSection from "../Common/FifthSection";
import InnovativeLeadership from "../Common/InnovativeLeadership";
import Awards from "../Common/Awards";
import Footer from "../../Components/Layout/Footer";
import "../../../src/App.css";

const Home = () => {
  return (
    <div className="overflow-x-hidden">
      <HeaderSection />
      <SecondComp />
      <LearnMoreaboutme />
      <AboutMyWork />
      <SomethingMore />
      <FifthSection />
      <InnovativeLeadership />
      <Awards />
      {/* <Footer /> */}
    </div>
  );
};

export default Home;
